import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.037 19.26a7.43 7.43 0 004.578-.22 7.489 7.489 0 003.6-2.86 7.59 7.59 0 001.259-4.443 7.556 7.556 0 00-1.54-4.308 7.551 7.551 0 00-3.787-2.622 7.462 7.462 0 00-2.185-.323c-2.433 0-4.086.92-5.37 2.362-1.11 1.249-1.54 2.783-1.54 3.965 0 3.462 3.315 5.704 6.736 5.704 1.527 0 2.948-1 2.948-2.179 0-3.26-5.632-1.813-5.632-4.628 0-1.234 1.173-2.222 2.687-2.222 1.513 0 2.56.9 2.732 1.686"
    })
  ]))
}